import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", "em;\n  text-align: center;\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  height: 50px;\n  justify-content: center;\n  width: 50px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", "em;\n  text-align: center;\n\n  &:first-child {\n    margin-top: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: ", "px ", "px;\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Heading2, Paragraph } from '@scp/ui-shared/components/typography';
import { size } from '@scp/ui-shared/theme/variables';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
var E2E_ITEM_SUFFIX = '-empty-list';
var Placeholder = styled.div(_templateObject(), function (props) {
  return props.concise ? size.gutterSmall : size.gutter;
}, size.gutterSmall);
var Title = styled(Heading2).attrs({
  noMargin: true,
  as: 'span'
})(_templateObject2(), 8 / 16);
var IconWrapper = styled.div(_templateObject3());
var Message = styled(Paragraph).attrs({
  secondary: true,
  as: 'span',
  noMargin: true
})(_templateObject4(), 4 / 14);
/**
 * Used as a simple placeholder for empty lists to have consistent UI.
 *
 * @example ./__docs__/EmptyList.md
 */

export function EmptyList(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      title = _ref.title,
      className = _ref.className,
      dataE2e = _ref.dataE2e,
      _ref$concise = _ref.concise,
      concise = _ref$concise === void 0 ? false : _ref$concise;
  return React.createElement(Placeholder, {
    className: className,
    concise: concise,
    "data-e2e": getE2eLabel('placeholder', E2E_ITEM_SUFFIX, dataE2e)
  }, icon && (concise ? icon : React.createElement(IconWrapper, null, icon)), React.createElement(Title, {
    "data-e2e": getE2eLabel('title', E2E_ITEM_SUFFIX)
  }, title), children && React.createElement(Message, {
    "data-e2e": getE2eLabel('message', E2E_ITEM_SUFFIX)
  }, children));
}